import deepFreeze from 'deep-freeze';
import { Markets } from '../types/market';

import gb from './gb';
import se from './se';
import fi from './fi';
import fr from './fr';
import ie from './ie';
import it from './it';
import no from './no';
import nz from './nz';
import pl from './pl';
import dk from './dk';

const markets: Markets = {
  gb,
  se,
  fi,
  fr,
  ie,
  it,
  no,
  nz,
  pl,
  dk,
};

export default deepFreeze(markets);
